import React, { Component } from 'react';
import DatePicker from 'bee-datepicker';
require('bee-datepicker/build/DatePicker.css');
import { isArray, isObj } from '@platform/api';
import moment from 'moment';
import { getDateFunNode, checkFuntionValue, getTimeFunctionLabel } from './dateFunction';
import { locale, localeLang, getDatetimeFormat, getMultiLang } from '@platform/api';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/en-au';
import { getSysFieldid } from '@platform/api';


const { RangePicker: OriginRangePicker } = DatePicker;
require('./index.less');

class RangePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
        };
    }
    componentWillMount() {
        let callback = json => {
            this.setState({ json, localeLang });
        }
        getMultiLang({ moduleId: ['page_search', 'common'], callback });
    }
    render() {
        let {
            format = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY.MM.DD', 'YYYY/MM/DD'],
            showStar,
            defaultValue,
            value,
            onChange,
            dateInputPlaceholder,
            showTimeFunction,
            placeholder,
            tableOpen,
            fieldid,
            dropdownClassName,
            ...others
        } = this.props;
        if (localeLang === 'simpchn') {
            moment.locale('zh-cn');
        } else if (localeLang === 'english') {
            moment.locale('en');
        } else if (localeLang === 'tradchn') {
            moment.locale('zh-tw');
        } else {
            moment.locale('zh-cn');
        }
        let defaultFormat = isArray(format) ? format[0] : format;
        let finalFormat = getDatetimeFormat(defaultFormat);
        // 添加了inputShowValue属性
        let inputShowValue = [];
        if (value) {
            inputShowValue = value.map(e => { let localLocale = moment(e); localLocale.locale('en'); return localLocale.format(finalFormat) });
        }
        if (getSysFieldid(fieldid)) {
            dropdownClassName = dropdownClassName ? dropdownClassName + ` fieldid_${fieldid}_calendar` : `fieldid_${fieldid}_calendar`;
        }
        let json = this.state.json
        let functionValue = value || [];
        if (checkFuntionValue(value)) {
            value = '';
            placeholder = ' ';
        }
        if (placeholder === undefined) {
            placeholder = json['common-0003'] || '开始 ~ 结束'
        }

        if (tableOpen) {
            return (
                <div
                    className={`u-form-control-wrapper nc-rangepicker-wrapper ${this.props.className}`}
                    onClick={e => {
                        e.stopPropagation();
                    }}
                    fieldid={getSysFieldid(fieldid) || null}
                >
                    {showStar ? <span className="range-picker-required-tag">*</span> : ''}
                    <OriginRangePicker
                        dropdownClassName={dropdownClassName + ' nc-rangepicker-calendar'}
                        className="nc-input"
                        format={format}
                        inputShowValue={inputShowValue}
                        locale={locale}
                        placeholder={placeholder}
                        dateInputPlaceholder={
                            dateInputPlaceholder || [
                                json['page-search-0039'] || '开始',
                                json['page-search-0040'] || '结束',
                            ]
                        }
                        renderIcon={this.props.renderIcon}
                        defaultValue={value ? value.map(e => moment(e)) : []}
                        onChange={v => {
                            this.props.onChange && this.props.onChange(v.map(e => e.format(isArray(format) ? format[0] : format)));
                            // this.props.onChange && this.props.onChange(v.map(e => e.format('YYYY-MM-DD')));
                        }}
                        value={value ? value.map(e => moment(e)) : []}
                        {...others}
                    />
                    {getTimeFunctionLabel(functionValue, showTimeFunction)}
                </div>
            );
        } else {
            return (
                <div
                    className={`u-form-control-wrapper nc-rangepicker-wrapper ${this.props.className}`}
                    onClick={e => {
                        e.stopPropagation();
                    }}
                    fieldid={getSysFieldid(fieldid) || null}
                >
                    {showStar ? <span className="range-picker-required-tag">*</span> : ''}
                    <OriginRangePicker
                        dropdownClassName={dropdownClassName + ' nc-rangepicker-calendar'}
                        className="nc-input"
                        inputShowValue={inputShowValue}
                        format={format}
                        locale={locale}
                        placeholder={placeholder}
                        dateInputPlaceholder={
                            dateInputPlaceholder || [
                                json['page-search-0039'] || '开始',
                                json['page-search-0040'] || '结束',
                            ]
                        }
                        renderIcon={this.props.renderIcon}
                        defaultValue={value ? value.map(e => moment(e)) : []}
                        onChange={v => {
                            this.props.onChange && this.props.onChange(v.map(e => e.format(isArray(format) ? format[0] : format)));
                            // this.props.onChange && this.props.onChange(v.map(e => e.format('YYYY-MM-DD')));
                        }}
                        value={value ? value.map(e => moment(e)) : []}
                        {...others}
                    />
                    {getTimeFunctionLabel(functionValue, showTimeFunction)}
                </div>
            );
        }
    }
}

RangePicker.defaultProps = {
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
    showClose: false,
};
export default RangePicker;
